import React from "react";
import SimpleClassicyWindow from "../window/SimpleClassicyWindow";
import { QuickTimeVideoEmbed } from "./QuickTimeMovieEmbed";

interface SimpleMoviePlayerProps {
  url: string;
  name: string;
  type: "audio" | "video";
  visualUrl?: string;
  top?: number | string;
  left?: number | string;
  width?: number | string;
  height?: number | string;
  onClose: () => void;
}

export const SimpleMoviePlayer: React.FC<SimpleMoviePlayerProps> = ({
  url,
  name,
  type,
  visualUrl,
  top,
  left,
  width,
  height,
  onClose,
}) => {
  return (
    <SimpleClassicyWindow
      title={name}
      icon=""
      closable={true}
      zoomable={false}
      collapsable={false}
      scrollable={false}
      isActive={true}
      width={width}
      height={height}
      top={top}
      left={left}
      onClose={onClose}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <QuickTimeVideoEmbed
          appId="movieplayer"
          name={name}
          url={url}
          type={type}
          visualUrl={visualUrl}
          autoPlay={false}
          hideControls={false}
          controlsDocked={true}
          muted={false}
        />
      </div>
    </SimpleClassicyWindow>
  );
};

export default SimpleMoviePlayer;
